import { cardTitle, title } from "../../../nextjs-material-kit.js";
import { container } from "../../../nextjs-material-kit.js";

const careerZoneGridStyle = {
  noUnderlineLinks: {
    a: {
      textDecoration: "none",
    },
  },
  section: {
    padding: "0 0",
    textAlign: "center",
  },
  cardTitle: {
    ...cardTitle,
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 900,
    textAlign: "center",
    color: "#095A70",
    fontSize: "60px",
    paddingLeft: "0px",
  },
  cardSubTitle: {
    fontFamily: "var(--font-brandon-grotesque)",
    textAlign: "center",
    color: "#000",
    fontSize: "17px",
  },
  cardDesc: {
    fontFamily: "var(--font-brandon-grotesque)",
    padding: "0",
    textAlign: "center",
    fontSize: "17px",
    fontWeight: "500",
    lineHeight: 1.25,
  },
  jobCard: {
    borderRadius: "0px",
    boxShadow: "none",
    color: "#095a70",
    paddingBottom: "0px",
    marginTop: "10px",
    marginBottom: "-3px",
    "@media (max-width: 768px)": {
      display: "block",
    },
  },
  blue: {
    backgroundColor: "#7db2e1",
  },
  purple: {
    backgroundColor: "#683f8c",
  },
  title: {
    textDecoration: "none",
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 900,
    fontSize: "6.5em",
  },
  container: {
    "@media (max-width: 768px)": {
      maxWidth: "100% !important",
    },
  },
  description: {
    color: "#999",
  },
  icon: {
    width: "159px",
    height: "auto",
  },
  iconNew: {
    width: "159px",
    height: "159px",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    img: {
      width: "80px",
      height: "80px",

    },
  },
};

export default careerZoneGridStyle;
